// src/pages/ClaimOfferPage.js
import React from 'react';

function ClaimOfferPage() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Claim Offer</h1>
      <p>This is a placeholder page for claiming special offers or discounts.</p>
    </div>
  );
}

export default ClaimOfferPage;
